import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { Assignment, Business, CalendarMonth } from "@mui/icons-material";
import { formatDate, formatText } from "../../../utils/utils";
import { ProjectModule } from "../types";

const ProjectBasicDetailView: React.FC<{
  projectDetails?: ProjectModule | null;
}> = ({ projectDetails }) => {
  if (!projectDetails) return null;
  return (
    <Paper sx={{ px: 2, py: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {/* Module Name */}
        <Typography
          variant="h5"
          sx={{
            fontSize: "1.25rem",
            fontWeight: 600,
            flex: "1 1 auto",
            minWidth: "200px",
          }}
        >
          {projectDetails.name}
        </Typography>

        {/* Client, Duration, Status Info */}
        <Box
          sx={{
            display: "flex",
            gap: 3,
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: "120px",
            }}
          >
            <Business sx={{ fontSize: "1rem", color: "text.secondary" }} />
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.7rem" }}
              >
                Client
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "0.75rem", fontWeight: 500 }}
              >
                {projectDetails.client?.clientName}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: "160px",
            }}
          >
            <CalendarMonth sx={{ fontSize: "1rem", color: "text.secondary" }} />
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.7rem" }}
              >
                Duration
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "0.75rem", fontWeight: 500 }}
              >
                {formatDate(projectDetails.startDate)} -{" "}
                {projectDetails.endDate
                  ? formatDate(projectDetails.endDate)
                  : "Ongoing"}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: "100px",
            }}
          >
            <Assignment sx={{ fontSize: "1rem", color: "text.secondary" }} />
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.7rem" }}
              >
                Status
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "0.75rem", fontWeight: 500 }}
              >
                {formatText(projectDetails.status)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Description */}
      {/* {projectDetails.description && (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {projectDetails.description}
        </Typography>
      )} */}
    </Paper>
  );
};

export default ProjectBasicDetailView;
